import * as React from 'react';

import styled from '@emotion/styled';

import { UserCategory, mapUserCategory } from '../../../utils/user';

type UserCategoryChipProps = {
  userCategory: UserCategory;
};

const mapUserCategoryColor: Record<UserCategory, string> = {
  [UserCategory.lifestyle]: '#37BB90',
  [UserCategory.select]: '#955CCC',
};

const ChipContainer = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 500;
  line-height: 100%;
  background-color: #f7f7f7;
  border: 1px solid #f0f0f0;
  color: ${(props) => props.color};
`;

const UserCategoryChip: React.FC<UserCategoryChipProps> = ({ userCategory }) => {
  const color = mapUserCategoryColor[userCategory];
  const label = mapUserCategory[userCategory];

  return <ChipContainer color={color}>{label}</ChipContainer>;
};

export default UserCategoryChip;
